import { render, staticRenderFns } from "./ModuleNav.vue?vue&type=template&id=3351e745&"
import script from "./ModuleNav.vue?vue&type=script&lang=js&"
export * from "./ModuleNav.vue?vue&type=script&lang=js&"
import style0 from "./ModuleNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports